import SplitType from 'split-type'

export const splitType = () => {
  // let debounce
  // let browserWidth = window.innerWidth

  document.fonts.ready.then(() => {
    
    const split = new SplitType('[data-split]', { types: 'lines, words' })
    const splitBanner = new SplitType('[data-split-banner]', { types: 'words' })
    const splitInner = new SplitType('[data-split-inner] p', { types: 'lines, words' })
    const splitChars = new SplitType('.navigation__main .menu-item a:not(.sub-menu a)', {
      types: 'chars'
    })

    // window.addEventListener('resize', () => {
    //   clearTimeout(debounce)
    //   debounce = setTimeout(() => {
    //     if (window.innerWidth != browserWidth) {
    //       browserWidth = window.innerWidth
    //       split.split()
    //       splitInner.split()
    //       splitChars.split()
    //     }
    //   }, 300)
    // })
  })
}

export default () => {}
